import React from 'react';
import { Rating as CorporateRating } from '../Corporate/Rating';
import StandardRating from './Rating';

/**
 * Rating Wrapper Component
 * Conditionally renders Corporate or Standard Rating based on environment variable
 */
const RatingWrapper = () => {
    // Check if corporate mode is enabled
    const isCorporateMode = process.env.REACT_APP_CORPORATE_MODE === 'true';

    if (isCorporateMode) {
        // Render Corporate Rating
        return <CorporateRating />;
    } else {
        // Render Standard Rating
        return <StandardRating />;
    }
};

export default RatingWrapper;
